<template>
<el-popover
  placement="bottom"
  trigger="click"
  @hide="popHide"
  >
<div class="content" >
    <div class="groupContainer" v-for="(item,index) in searchFilterList" :key="index" > 
        <div class="title">{{item.categorylabel}}</div>
        <el-checkbox-group  v-model="checkList" @change="handleItemGroupClick">
            <div class="checkBoxDiv" v-for="(itemy,indey) in item.selectItems" :key="indey" >
                <el-checkbox 
                 @change="checked => handleItemClick(checked, itemy)" 
                 :label=itemy.cfgID :disabled=itemy.disable 
                 
                 >
                 {{itemy.label}}
                </el-checkbox>
            </div>
        </el-checkbox-group>
    </div>
</div>

   <el-button slot="reference" class="but" @click="searchFilter" >搜索筛选</el-button>
</el-popover>
</template>

<script>
export default {
    props: {
        searchFilterList: {
            default: () => {
                return
            },
            type: Array
        },
        checkList: {
            default: () => {
                return
            },
            type: Array
        }
   },
   data () {
      return {
        
      };
    },
   methods: {
    searchFilter() {
       this.$emit('searchFilter')
    },
    handleItemGroupClick(value) {
        // 选中项修改
        // 调用借口增加筛选项
        console.log(value, '点击了====》');
        console.log(this.checkList, '======>');
        this.$emit('checkBoxedChange', value);
    },
    handleItemClick(checked, item) {
        console.log(checked, '单个点击====》00000',item);
        this.$emit('clickSingleBoxed',checked,item)
    },
    popHide(value) {
        console.log('pophide--------->');
        this.$emit('popHide', this.checkList);
    }
   }  
}

</script>

<style scoped lang="scss">
  
.content {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    .groupContainer {
        margin-right: 80px;
        &:last-child {
            margin-right: 0px;
        }
    }
    .title {
        font-size: 18px;
        font-weight: 500;
        color: black;
        margin-bottom: 4px;
    }
    .checkBoxDiv {
        .el-checkbox {
            font-size: 18px;
        }
    }
}

</style>